<template>
    <!-- min-h-full (not min-h-screen): this renders inside the shell's scroll
         container, which already subtracts the navbar/footer -->
    <div class="min-h-full flex items-center justify-center py-16">
        <div class="text-center px-6">
            <p class="text-8xl font-bold text-primary-500 dark:text-primary-400 mb-6" aria-hidden="true">404</p>
            <h1 class="text-3xl font-semibold text-neutral-900 dark:text-neutral-100 mb-4">We couldn't find that page.</h1>
            <p class="text-lg text-neutral-600 dark:text-neutral-400 max-w-2xl mx-auto">
                The page you're looking for doesn't exist or may have moved.
            </p>
            <div class="mt-8 flex flex-wrap items-center justify-center gap-3">
                <Button variant="primary" @click="$router.push('/')">Back to Dashboard</Button>
                <Button variant="secondary" @click="$router.back()">Go back</Button>
            </div>
        </div>
    </div>
</template>

<script>
import Button from '@/components/ui/Button.vue'

export default {
    name: 'NotFound',
    components: { Button },
}
</script>
